var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[(_vm.img!=='')?_c('img',{attrs:{"src":_vm.img}}):_vm._e(),_c('div',[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }